<template>
<div class="shadow-box">
  <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0; margin-bottom: 0;">
    <span>报单汇总</span>
    <span></span>
  </div>
  <div class="page-main_box" style="height: calc(100vh - 148px);">
    <!-- 1-已跟单,2-已丢单,3-已返款 -->
    <!-- <div class="tabs">
      <span :class="['item', curTab == '' ? 'active' : '']" @click="curTab = ''">全部</span>
      <span :class="['item', curTab == '1' ? 'active' : '']" @click="curTab = '1'">已跟单</span>
      <span :class="['item', curTab == '2' ? 'active' : '']" @click="curTab = '2'">已丢单</span>
      <span :class="['item', curTab == '3' ? 'active' : '']" @click="curTab = '3'">已返款</span>
    </div> -->
    <div class="search-box" style="padding-top: 12px;">
      <div class="flex-row">
        <div class="search-item">
          <div class="label">三方订单号：</div>
          <el-input v-model="form.thirdOrderSn" @blur="goSearch" @clear="goSearch" clearable placeholder="请输入三方订单号"></el-input>
        </div>
        <div class="search-item">
          <div class="label">商品名称：</div>
          <el-input v-model="form.goodsName" @blur="goSearch" @clear="goSearch" clearable placeholder="请输入商品名称"></el-input>
        </div>
        <div class="search-item">
          <div class="label">报单时间：</div>
          <el-date-picker
            v-model="form.reportDate"
            style="width: 220px"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="goSearch">
          </el-date-picker>
        </div>
        <div class="search-item">
          <div class="label">付款时间：</div>
          <el-date-picker
            v-model="form.orderPayTime"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 220px"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="goSearch">
          </el-date-picker>
        </div>
        <div class="search-item">
          <div class="label">收货时间：</div>
          <el-date-picker
            v-model="form.orderReceiveTime"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 220px"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="goSearch">
          </el-date-picker>
        </div>
      </div>
      <div class="flex-row flex-main-axis-between">
        <div class="flex-row"> 
          <div class="search-item">
            <div class="label">订单状态：</div>
            <!-- 1-已跟单,2-已丢单,3-已返款 -->
            <el-select clearable v-model="form.reportStatus" @change="goSearch" placeholder="选择状态">
              <el-option :value="''" label="全部"></el-option>
              <el-option :value="1" label="已跟单"></el-option>
              <el-option :value="2" label="已丢单"></el-option>
              <el-option :value="3" label="已返款"></el-option>
            </el-select>
          </div>

          <template>
            <div class="search-item">
              <div class="label">一级账号：</div>
              <el-select clearable filterable v-model="form.parentQdAccountId" @change="oneQdChange" placeholder="请选择">
                <el-option v-for="item in groupList1"
                :key="item.accountId"
                :value="item.accountId"
                :label="item.nickName"></el-option>
              </el-select>
            </div>
            <div class="search-item">
              <div class="label">二级账号：</div>
              <el-select clearable filterable :disabled="!form.parentQdAccountId" v-model="form.qdAccountId" @change="goSearch" placeholder="请选择">
                <el-option v-for="item in groupList2"
                :key="item.accountId"
                :value="item.accountId"
                :label="item.nickName"></el-option>
              </el-select>
            </div>
          </template> 

          <!-- 收入佣金 超管不显示 -->
          <div class="search-item" v-if="roleType && roleType != 1">
            <div class="label">收入佣金：</div>
            <!-- 1-已返 0-未返 -->
            <el-select clearable v-model="form.incomeStatus" @change="goSearch" placeholder="选择状态">
              <el-option :value="''" label="全部"></el-option>
              <el-option :value="1" label="已返"></el-option>
              <el-option :value="0" label="未返"></el-option>
            </el-select>
          </div>

          <el-button type="primary" @click="goSearch">查 询</el-button>
        </div>
      </div>
    </div>

    <!-- 超管 / 一级 -->
    <div class="summary-line flex-row flex-main-axis-between" style="padding-bottom: 16px;">
      <div>
        <!-- <el-button type="primary" v-if="roleType !== 1" @click="showAddReportHandler">新增报单</el-button>
        <el-button type="primary" :disabled="!multipleSelection.length" @click="showBatchDialogHandler">批量返款</el-button> -->
        <el-button type="primary" :disabled="pageInfo.total === 0" @click="getAllList"
          icon="el-icon-download"
          :loading="downloadLoading"
        >导出</el-button>
      </div>

      <div class="summary-line" v-if="roleType === 1">
        跟单订单数：<b class="primary-color">{{ summaryData.orderCount || 0 }}</b>  &nbsp;   跟单订单金额：<b class="primary-color">{{summaryData.orderAmount | filterAmount}}</b>  &nbsp;  跟单支出总佣金：<b class="primary-color">{{ summaryData.promotionAmount | filterAmount }}</b>
      </div>
      <div class="summary-line" v-if="roleType === 3">
        跟单订单数：<b class="primary-color">{{ summaryData.orderCount || 0 }}</b>  &nbsp; 跟单订单金额：<b class="primary-color">{{summaryData.orderAmount | filterAmount}}</b>  &nbsp; 
        <template v-if="isXiaomi">订单总佣金：<b class="primary-color">{{ computedRebatePromotionAmount(summaryData)}}</b></template>
        <template v-else>跟单佣金：<b class="primary-color">{{ summaryData.promotionAmount | filterAmount }}</b></template>
      </div>
      <div class="summary-line" v-if="roleType === 2">
        跟单订单数：<b class="primary-color">{{ summaryData.orderCount || 0 }}</b>  &nbsp;     跟单订单金额：<b class="primary-color">{{summaryData.orderAmount | filterAmount}}</b>  &nbsp;
      </div>
    </div>

    <div class="code-list-content">
      <el-table
        border
        stripe 
        v-if="roleType"
        ref="multipleTable"
        style="width: calc(100vw - 280px);"
        height="calc(100vh - 350px)"
        :data="tableData"
        @selection-change="handleSelectionChange"
        v-loading="isLoading"
      >
        <el-table-column
          fixed
          type="selection"
          :selectable="selectableRow"
          width="55">
        </el-table-column>
        <el-table-column
          prop="orderId"
          fixed
          label="订单号"
          min-width="80">
        </el-table-column>
        <el-table-column
          prop="thirdOrderSn"
          label="第三方订单号"
          min-width="120"> 
        </el-table-column>
        <el-table-column
          prop="type"
          label="第三方平台"
          min-width="120">
          <template slot-scope="{ row }">
            <div>{{ row.type | filterThirdType }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="realGoodsId"
          label="商品ID"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="goodsName"
          label="商品标题"
          min-width="120">
        </el-table-column>
        <!-- 单位为 分 -->
        <el-table-column
          prop="orderAmount"
          label="金额"
          min-width="120">
          <template slot-scope="{ row }">
            <div>{{ row.orderAmount | filterAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsThumbnailUrl"
          label="商品图片"
          min-width="120">
          <template slot-scope="{ row }">
            <div>
              <el-image
                v-if="row.goodsThumbnailUrl"
                shape="square"
                :preview-src-list="[row.goodsThumbnailUrl]"
                style="width: 80px; height: 80px;"
                fit="cover" :src="row.goodsThumbnailUrl"></el-image>
              <span v-else>--</span>
            </div>
          </template>
        </el-table-column>
        <!-- 十万分比 -->
        <el-table-column
          prop="promotionRate"
          label="佣金比"
          min-width="120">
          <template slot-scope="{ row }">
            <div>{{ row | filterPromotionRate}}</div>
          </template>
        </el-table-column>
        <!-- 单位为分 -->
        <el-table-column
          prop="promotionAmount"
          label="佣金"
          min-width="120">
          <template slot-scope="{ row }">
            <div>{{ row.promotionAmount | filterAmount }}</div>
          </template>
        </el-table-column>
        <!-- 4.7-->
        <!-- 补贴佣金比例 -->
        <el-table-column
          v-if="isXiaomi"
          prop="subsidyPromotionRate"
          label="补贴佣金比例"
          min-width="120">
          <template slot-scope="{ row }">
            <div>{{ (row.subsidyPromotionRate !== null && row.subsidyPromotionRate !== undefined) ? (row.subsidyPromotionRate || 0) * 100 + '%' : '--' }}</div>
          </template>
        </el-table-column>
        <!-- 补贴佣金 -->
        <el-table-column
          prop="promotionRate"
          v-if="isXiaomi"
          label="补贴佣金"
          min-width="120">
          <template slot-scope="{ row }">
            <div>{{ row.subsidyAmount | filterAmount}}</div>
          </template>
        </el-table-column>
        <!-- 订单总佣金 -->
        <el-table-column
          label="订单总佣金"
          v-if="isXiaomi"
          min-width="120">
          <template slot-scope="{ row }">
            <div>{{ row | filterDdzyj }}</div>
          </template>
        </el-table-column>
        <!-- 补贴描述 -->
        <el-table-column
          prop="rebateInfoType"
          v-if="isXiaomi"
          label="佣金比例描述"
          min-width="120">
          <template slot-scope="{ row }">
            <div>{{ row.rebateInfoType | filterRebateInfoType }}</div>
          </template>
        </el-table-column>
        <!-- /4.7-->
        <el-table-column
          prop="orderStatus"
          label="订单状态"
          min-width="120"> 
          <template slot-scope="{ row }">
            <div>
              {{ row.orderStatus | filterOrderStatus }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="duoDanNum"
          label="多单数"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="reportTime"
          label="报单时间"
          min-width="150">
          <template slot-scope="{ row }">
            <div>
              {{ row.reportTime | filterDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderPayTime"
          label="付款时间"
          min-width="150">
          <template slot-scope="{ row }">
            <div>
              {{ row.orderPayTime | filterDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderReceiveTime"
          label="收货时间"
          min-width="150">
          <template slot-scope="{ row }">
            <div>
              {{ row.orderReceiveTime | filterDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="parentQdAccountName"
          label="归属渠道"
          v-if="roleType !== 2"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="qdAccountName"
          label="归属二级渠道"
          min-width="120">
        </el-table-column>
        <!-- * 一级渠道报单状态 1-已跟单,2-已丢单,3-已返款 -->
        <el-table-column
          prop="qdReportStatus"
          label="报单状态"
          min-width="120">
          <template slot-scope="{ row }">
            <div>
              <!-- 1-超管 2-二级渠道 3-一级渠道 -->
              <!-- 超管 -->
              <div v-if="roleType == 1"> 
                {{ row.qdReportStatus | filterReportStatus }}
              </div>
              <!-- 一级账号 -->
              <div v-if="roleType == 3">
                {{ row.qdSubReportStatus | filterReportStatus }}
              </div>
              <div v-else-if="roleType == 2">
                {{ row.clientReportStatus | filterReportStatus }}
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 
          qdCommissionIncomeStatus: 一级渠道佣金收取 1-已返 0-未返
        -->
        <el-table-column
          label="收入佣金"
          v-if="roleType && roleType != 1"
          min-width="120">
          <template slot-scope="{ row }">
            <!-- 超管 -->
            <!-- <div v-if="roleType == 1">
              {{ row.qdCommissionIncomeStatus | filterIncomeStatus }}
            </div> -->
            <!-- 一级 -->
            <div v-if="roleType == 3">
              {{ row.qdCommissionIncomeStatus | filterIncomeStatus }}
            </div>
            <!-- 二级 -->
            <div v-if="roleType == 2">
              {{ row.qdSubCommissionIncomeStatus | filterIncomeStatus }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="receiveFlag"
          label="领取状态"
          min-width="120">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.receiveFlag === 0">未领取</span>
              <span v-if="row.receiveFlag === 1">已领取</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="commissionAmount"
          label="用户返利"
          min-width="120">
          <template slot-scope="{ row }">
            <div>{{ row.commissionAmount | filterAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="commissionValidStatus"
          label="佣金状态"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="commissionValidReason"
          label="佣金无效原因"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="reportSource"
          label="报单入口"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="reportAccountName"
          label="报单用户"
          min-width="120">
        </el-table-column>
      </el-table>
      <div class="bd--pag flex-row flex-main-axis-between">
        <div v-if="roleType == 1">
          <span style="color: #999; font-size: 12px; padding-right: 12px;">共勾选 <b>{{ multipleSelection.length }}</b> 条数据</span>
          <el-button @click="batchDelHandler" :disabled="!multipleSelection.length">批量删除</el-button>
        </div>
        <div v-else></div>

        <el-pagination
          v-if="pageInfo.total > 0"
          class="d-ib"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          :page-sizes="pageInfo.sizes"
          :page-size="pageInfo.size"
          :current-page="pageInfo.current"
          @current-change="pageInfo.current = arguments[ 0 ], getList()"
          @size-change="pageInfo.size = arguments[ 0 ], getList()">
        </el-pagination>
      </div> 
    </div>
  </div>

  <!-- 批量返款 -->
  <RefundBatchDialog
    v-if="showBatchDialog"
    v-model="showBatchDialog"
    :list="multipleSelection"
    :roleType="roleType"
    @close="showBatchDialog = false"
    @on-success="successHandler"
  ></RefundBatchDialog>

  <!-- 新增 -->
  <AddReportDialog
    v-if="showAddReportDialog"
    v-model="showAddReportDialog"
    :roleType="roleType"
    @close="showAddReportDialog = false"
    @on-success="showAddResultDialogHandler"
  />

  <AddResultDialog
    v-if="showAddResultDialog"
    v-model="showAddResultDialog"
    @close="showAddResultDialog = false; importResult = {}"
    :importResult="importResult"
    @on-success="addReportSuccessHandler"
  />

</div>
</template>
<script>
import RefundBatchDialog from '@/page/component/sections/order/refund-batch-dialog.vue'
import AddReportDialog from '@/page/component/sections/order/add-report-dialog.vue'
import AddResultDialog from '@/page/component/sections/order/add-result-dialog.vue'
import {
  getAccountRoleType,
  queryOrderReportAllWeb,
  queryOrderReportAllSum,
  removeOrderReportWeb
} from '@/service/apis/order'
import { getParentAccountId, getAccountId } from '@/directives/permission'
import moment from 'moment'
import { douyinM2SPageList } from '@/service/apis/group'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { getFields, typeMap, getOrderStatus, moneyFormatFn, computedPromotionRate, rebateInfoTypes } from '../order-list/fields'
import { getUserId } from '@/utils/getUser' 
const dayjs = require('dayjs')

export default {
  components: { 
    RefundBatchDialog,
    AddReportDialog,
    AddResultDialog
   },
   computed: {
    fields () {
      return getFields(this.roleType)
    },
    // 一级账号 可见 || 小米的二级账号
    isXiaomi () {
      // return this.roleType === 3 || (getParentAccountId() === '2576247038583552' && this.roleType == 2)
      return getAccountId() == '2576247038583552' // 小米
    }
  },
  data () {
    return {
      downloadLoading: false,
      allList: [],
      form: {
        thirdOrderSn: '',
        goodsName: '',
        reportDate: [],
        orderPayTime: [],
        orderReceiveTime: [],
        reportStatus: '',
        incomeStatus: '',
        parentQdAccountId: '', // 一级账号,
        qdAccountId: '' // 二级账号
      },
      curTab: '',
      pageInfo: {
        current: 1,
        size: 10,
        sizes: [ 10, 20, 30, 50, 100 ],
        pages: 0,
        total: 0
      },
      // 1-超管 2-二级渠道 3-一级渠道
      roleType: null,
      isLoading: false,
      tableData: [],
      editRow: null, 
      showBatchDialog: false,
      showReportSum: false,
      summaryData: {},
      multipleSelection: [],
      showAddReportDialog: false,
      groupList1: [],
      groupList2: [],
      importResult: {},
      showAddResultDialog: false
    }
  },
  filters: {
    filterThirdType (type) {
      return typeMap[type] || '--'
    },
    filterDate (date) {
      if (date) {
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
      }
      return '--'
    },
    filterRebateInfoType (type) {
      return rebateInfoTypes[type] || '--'
    },
    filterAmount (amount) {
      return moneyFormatFn(amount) || '--'
    },
    filterDdzyj (row) {
      // 佣金 promotionAmount+补贴佣金 subsidyAmount
      return moneyFormatFn((row.promotionAmount || 0) + (row.subsidyAmount || 0))
    },
    filterPromotionRate (row) {
      return computedPromotionRate(row) || '--'
    },
    filterIncomeStatus (status) { 
      // 1是已返 0是未返
      return status == 1 ? '已返' :
        status == 0 ? '未返' : '--'
    },
    filterOrderStatus (status) {
      return getOrderStatus(status) || '--'
    },
    filterReportStatus (status) {
      if (status == 1) {
        return '已跟单'
      } else if (status == 2) {
        return '已丢单'
      } else if (status == 3) {
        return '已返款'
      }
      
      return '---'
    }
  },
  async created () {
    // 获取角色
    await this.getAccountRoleType()

    this.$nextTick(() => {
      this.getList()
      // 汇总数据
      this.queryOrderReportSum()
    })
  },
  methods: {
    computedRebatePromotionAmount (row) {
      // 佣金 promotionAmount+补贴佣金 promotionAmount
      return moneyFormatFn((row.rebatePromotionAmount || 0) + (row.promotionAmount || 0))
    },
    batchDelHandler () {
      const ids = this.multipleSelection.map(item => item.thirdOrderSn)
      this.$confirm(`选中${this.multipleSelection.length}条数据，确定删除选中的数据吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeOrderReportWeb.call(this, ids).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.multipleSelection = []
          this.goSearch()
        })
        // let list = []
        // ids.forEach(id => {
        //   list.push(delKlLiveRoomProduct.call(this, {
        //     liveRoomId: id
        //   }))
        // })
        // Promise.all(list).then(() => {
        //   this.$message({
        //     type: 'success',
        //     message: '删除成功'
        //   })
        //   this.multipleSelection = []
        //   this.goSearch()
        // })
      })
    },
    goSearch () {
      this.pageInfo.current = 1
      this.getList()
      // 汇总数据
      this.queryOrderReportSum()
    },
    oneQdChange (val) {
      this.form.qdAccountId = ''
      this.getGroupList2(val)
      this.goSearch()
    },
    async getAllList() {
      this.downloadLoading = true
      const pageSize = 500
      const pages = Math.ceil(this.pageInfo.total / pageSize)
      const list = []
      const params = this.getParams()
      if (pages >= 0) {
        for (let i = 0; i < pages; i++) {
          list.push(queryOrderReportAllWeb.call(this, {
            pageIndex: i + 1,
            pageSize: pageSize,
            ...params
          }))
        }
      }
      const data = await Promise.all(list)
      if (data.length) {
        const allList = []
        data.forEach(item => {
          allList.push(...(item.records || []))
        })
        this.allList = allList
        this.downloadExcel()
      }
    },
    // 导出
    downloadExcel() {
      const heads = []
      const baseKeys = []
      this.fields.forEach(item => {
        if (typeof item.needExport === 'undefined' || (typeof item.needExport === 'function' && item.needExport())) {
          heads.push(item.label)
          baseKeys.push(item.key)
        }
      })
      
      const data = [
        [...heads]
      ]

      this.allList.forEach(item => {
        const values = []
        this.fields.forEach(field => { 
          if (typeof item.needExport === 'undefined' || (typeof item.needExport === 'function' && item.needExport())) {
            let val = item[field.key] || ''
            if (field.format) {
              val = field.format(item)
            }
            values.push(item.type === 'number' ? { t: 's', v: val } : val)
          }
        })

        data.push(values)
      })

      this.downloadLoading = false
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data)

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

      // 使用blob和FileReader创建一个URL然后下载
      const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
      // 
      saveAs(dataBlob, `报单列表 ${dayjs().format('YYYYMMDDHHmmss')}.xlsx`)
    },
    showAddReportHandler () {
      this.showAddReportDialog = true
    },
    selectableRow (row) {
      let key = ''
      if (this.roleType == 1) {
        key = 'qdReportStatus'
      } else if (this.roleType == 3) {
        key = 'qdSubReportStatus'
      } else if (this.roleType == 2) {
        key = 'clientReportStatus'
      }

      // idsAids
      // 只有跟单可以选
      //超管，全部可以选
      return this.roleType == 1 ? true : row[key] == 1
    },
    showBatchDialogHandler () {
      this.showBatchDialog = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getAccountRoleType () {
      getAccountRoleType.call(this, {
        accountId: getUserId() // getUserId()
      }).then(res => {
        if (res) {
          this.roleType = res
          // 获取账号列表
          this.getAccountList()
        }
      })
    },
    getAccountList (parentId) {
      // 超管 - 查看所有一级 1
      // 0就是二级
      douyinM2SPageList.call(this, {
        one: 1,
        current: 1,
        size: 1000
      }).then(res => {
        this.groupList1 = res.records || []
      }) 
    },
    getGroupList2 (parentId) {
      douyinM2SPageList.call(this, {
        one: 0, // 二级
        current: 1,
        size: 1000,
        parentId
      }).then(res => {
        this.groupList2 = res.records || []
      })
    },
    queryOrderReportSum () {
      this.showReportSum = false
      let params = this.getParams()
      queryOrderReportAllSum.call(this, {
        ...params,
        accountId: getUserId() // 登录账号
      }).then((res) => {
        this.summaryData = {...(res || {})}
        this.showReportSum = true
      })
    },
    getParams () {
      let form = JSON.parse(JSON.stringify(this.form))
      // 报单时间
      if (form.reportDate.length) {
        form.reportDateBegin = form.reportDate[0]
        form.reportDateEnd = moment(form.reportDate[1]).format('YYYY-MM-DD') + ' 23:59:59' 
      }
      delete form.reportDate
      // 支付时间
      if (form.orderPayTime && form.orderPayTime.length) {
        form.orderPayTimeBegin = form.orderPayTime[0]
        form.orderPayTimeEnd = moment(form.orderPayTime[1]).format('YYYY-MM-DD') + ' 23:59:59' 
      }
      delete form.orderPayTime
      // 收货时间
      if (form.orderReceiveTime && form.orderReceiveTime.length) {
        form.orderReceiveTimeBegin = form.orderReceiveTime[0]
        form.orderReceiveTimeEnd = moment(form.orderReceiveTime[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      delete form.orderReceiveTime

      // 角色：1-超管 2-二级渠道 3-一级渠道 
      if (form.reportStatus) {
        switch (this.roleType) {
          case 1:
            form.qdReportStatus = form.reportStatus
            break
          case 2:
            form.clientReportStatus = form.reportStatus
            break
          case 3:
            form.qdSubReportStatus = form.reportStatus
            break
        }
      }
      delete form.reportStatus

      // 佣金
      if (form.incomeStatus !== '') {
        switch (this.roleType) {
          // case 1:
          //   form.qdCommissionIncomeStatus = form.incomeStatus
          //   break
          case 2:
            form.qdSubCommissionIncomeStatus = form.incomeStatus
            break
          case 3:
            form.qdCommissionIncomeStatus = form.incomeStatus
            break
        }
      }
      delete form.incomeStatus
      
      form.accountId = getUserId() // 登录账号

      let rst = {}
      for (let key in form) {
        if (form[key] !== '' && form[key] !== null && form[key] !== undefined) {
          rst[key] = form[key]
        }
      }

      return rst
    },
    getList () { 
      this.isLoading = true
      this.tableData = []
      let params = this.getParams()

      queryOrderReportAllWeb.call(this, {
        ...params,
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size
      }).then((res) => {
        const {records, pages, total} = res
        this.pageInfo.total = total || 0
        this.pageInfo.pages = pages || 0
        this.tableData = [...(records || [])]
      }).finally(() => {
        this.isLoading = false
      })
    },
    // 新增、修改回调
    successHandler () {
      this.showBatchDialog = false
      this.multipleSelection = []
      this.$refs.multipleTable.clearSelection()
      this.getList()
    },
    showAddResultDialogHandler (rst) {
      this.showAddReportDialog = false
      this.importResult = rst
      this.showAddResultDialog = true
      // this.getList()
    },
    addReportSuccessHandler() {
      this.showAddResultDialog = false
      this.getList()
    }
  }
}
</script>
<style scoped>
.search-box .flex-row {
  padding-bottom: 12px;
}
.search-box .flex-row:last-child {
  padding-bottom: 0;
}
.summary-line {
  height: auto;
  overflow: hidden;
  font-size: 14px;
  line-height: 28px;
  color: #666; 
} 
</style>
